import axios from "axios";
import {BASE_URL} from "../environment";

//create new payment
export const createPayment = async (payment) => {
    try {
        const response = await axios.post(`http://${BASE_URL}:8000/api/payments`, payment);
        return response.data;
    } catch (error) {
        throw new Error(error.response.data.message || 'Failed to create payment');
    }
};

export const editPayment = async (payment) => {
    try {
        const response = await axios.put("/payment/"+payment._id, payment);
        return response.data;
    } catch (error) {
        throw new Error(error.response.data.message || 'Failed to create payment');
    }
};

export const cancelPayment = async (payment) => {
    try {
        const response = await axios.delete("/payment/"+payment._id);
        return response.data;
    } catch (error) {
        throw new Error(error.response.data.message || 'Failed to create payment');
    }
};